function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a2e0af23-4ced-4921-9ce0-827007506601",
  x1: 1755.38,
  y1: 741.53,
  x2: 1755.38,
  y2: 284.16,
  gradientTransform: "translate(-1462.23)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "3d modeling");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1034.91,695.5c5.94-11-.8-24.46-8.54-34.27s-17.18-20-17-32.49c.29-18,19.34-28.55,34.57-38.07a169.08,169.08,0,0,0,31-24.95c3.73-3.82,7.35-7.9,9.53-12.77,3.15-7,3.06-15,2.86-22.69q-1-38.43-3.79-76.78",
  transform: "translate(-56.56 -127.37)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1112.54,452.08a28,28,0,0,0-14-22.93l-6.27,12.4.19-15a28,28,0,1,0,20.06,25.55Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1062.61,641.57A28,28,0,1,1,1064,619l-17.48,14.23,19.23-4.46A27.66,27.66,0,0,1,1062.61,641.57Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1048.79,587.21a28,28,0,0,1-29.28-26.66,27.65,27.65,0,0,1,2.42-12.75,28,28,0,0,1,18-15.51l-.14,11.54,6.34-12.55h.07a28,28,0,1,1,2.62,55.94Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1116.75,542a28,28,0,1,1,12.38-52.39l-5,13.55,10.18-9.77a27.92,27.92,0,0,1,9,19.33,27.34,27.34,0,0,1-.71,7.71A28,28,0,0,1,1116.75,542Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1108.77,459.54c-6.46.71-12.74,2.72-19.23,3.13s-13.6-1.16-17.71-6.2c-2.21-2.71-3.31-6.15-5.18-9.11a19.94,19.94,0,0,0-7.05-6.64,28,28,0,1,0,52.34,18.59C1110.88,459.35,1109.82,459.43,1108.77,459.54Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1116.75,542a28,28,0,0,1-26.63-39.94,20.7,20.7,0,0,1,5.63,5.64c2,3,3.2,6.49,5.55,9.25,4.35,5.13,11.8,6.81,18.56,6.49s13.28-2.22,20-2.84c.93-.08,1.88-.15,2.82-.17A28,28,0,0,1,1116.75,542Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1048.79,587.21a28,28,0,0,1-29.28-26.66,27.65,27.65,0,0,1,2.42-12.75,22.75,22.75,0,0,1,5.92,5.69c2.17,3.07,3.53,6.6,6.07,9.44,4.72,5.26,12.66,7.11,19.82,6.94,6.94-.15,13.61-1.85,20.5-2.38A28,28,0,0,1,1048.79,587.21Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1062.61,641.57a28,28,0,0,1-51-22.84,27.93,27.93,0,0,1,6.14,5.48c2.66,3.25,4.42,6.92,7.5,9.95,5.72,5.61,15,7.93,23.19,8.15A121.6,121.6,0,0,0,1062.61,641.57Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 552.2,
  cy: 594.27,
  rx: 510,
  ry: 51,
  fill: "#123f73",
  opacity: 0.1
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M147.41,238.36a18.18,18.18,0,0,1,4.51-16.85l6.18,6.57-2.87-9.31a18.18,18.18,0,1,1-7.82,19.59Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.13,242.32c4.15-.74,8.44-.64,12.55-1.58s8.27-3.21,9.9-7.1c.88-2.1.94-4.44,1.56-6.63a12.89,12.89,0,0,1,3.18-5.43,18.19,18.19,0,1,1-29.21,21.17C149.78,242.59,150.45,242.44,151.13,242.32Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M995.57,130.09a14.71,14.71,0,0,1,14-1.67l-3.09,6.61,6.13-4.94a14.68,14.68,0,1,1-17,0Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M993.72,134.07c1.8,2.89,3,6.13,4.94,8.94s4.89,5.24,8.3,5.29c1.83,0,3.61-.62,5.43-.81a10.56,10.56,0,0,1,5,.75,14.69,14.69,0,1,1-24.63-15.56C993.11,133.13,993.43,133.59,993.72,134.07Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M1057.23,202.2a17,17,0,0,1,16.2-1.93l-3.57,7.65,7.1-5.73a17,17,0,1,1-19.73,0Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1055.08,206.8c2.09,3.35,3.48,7.11,5.73,10.36s5.65,6.06,9.6,6.13c2.13,0,4.18-.73,6.3-.95a12.15,12.15,0,0,1,5.81.88,17,17,0,1,1-28.52-18C1054.38,205.72,1054.74,206.25,1055.08,206.8Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M213,593.31c-8.79-8.87-6.13-23.7-1.47-35.29s10.84-24,7.12-36c-5.34-17.14-26.61-21.94-43.9-26.77A168.59,168.59,0,0,1,138,480.1c-4.66-2.6-9.28-5.5-12.75-9.56-5-5.84-7.17-13.53-9.15-21q-9.89-37.14-18-74.72",
  transform: "translate(-56.56 -127.37)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.87,381.68a28,28,0,0,1,6.94-25.95l9.51,10.13-4.41-14.35a28,28,0,1,1-12,30.17Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.24,549.38a28,28,0,1,0-7.66-21.24l20.79,8.71L164.66,538A27.72,27.72,0,0,0,171.24,549.38Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.16,493.33a28,28,0,0,0-7-55.2l3.39,11L156,438.91l-.07,0a28,28,0,1,0,13.27,54.4Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.2,469.12a28,28,0,1,0-26.66-46.77L73.11,434l-12.52-6.51a27.91,27.91,0,0,0-3.22,21.1,27.54,27.54,0,0,0,2.85,7.2A28,28,0,0,0,91.2,469.12Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#123f73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.59,387.77c6.4-1.14,13-1,19.33-2.43s12.73-4.94,15.24-10.93c1.36-3.23,1.45-6.84,2.4-10.21a20.07,20.07,0,0,1,4.89-8.36,28,28,0,1,1-45,32.6C73.51,388.19,74.55,388,75.59,387.77Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.2,469.12a28,28,0,0,0,14.28-45.83,20.69,20.69,0,0,0-3.81,7c-1.06,3.44-1.24,7.12-2.71,10.44-2.74,6.15-9.41,9.86-16,11.47s-13.37,1.61-20,2.91c-.92.19-1.84.39-2.76.64A28,28,0,0,0,91.2,469.12Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.16,493.33a28,28,0,0,0,14.65-45.39,22.58,22.58,0,0,0-4.07,7.13c-1.22,3.56-1.53,7.33-3.17,10.77-3,6.37-10.14,10.39-17,12.25-6.7,1.81-13.58,2.06-20.34,3.5A28,28,0,0,0,169.16,493.33Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.24,549.38a28,28,0,0,0,42.52-36.31,27.5,27.5,0,0,0-4.35,7c-1.64,3.86-2.28,7.88-4.39,11.65-3.9,7-12.11,11.84-19.94,14.37A122.41,122.41,0,0,1,171.24,549.38Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M1040,197.35l-.22,498.29c-35,0,0,0-35.34.18H872.93l-.4-.16a81.06,81.06,0,0,0-61.23,0l-.33.14H679.18q-6.66-2.7-13-5.92a78.73,78.73,0,0,0-70.74,0q-6.39,3.21-13,5.92H450.55l-.33-.14a81.06,81.06,0,0,0-61.23,0l-.4.16H257.1a177,177,0,0,1-59.81-40.18V197.35Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1040,177.86v21.49H197.28V177.86a7.37,7.37,0,0,1,7.38-7.38H1032.6A7.37,7.37,0,0,1,1040,177.86Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#ededf4"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 154.08,
  cy: 57.33,
  r: 3.45,
  fill: "#fa5959",
  opacity: 0.8
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 163.56,
  cy: 57.33,
  r: 3.45,
  fill: "#fed253",
  opacity: 0.8
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 173.03,
  cy: 57.33,
  r: 3.45,
  fill: "#8ccf4d",
  opacity: 0.8
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M307.76,199.35V696.82s-45-.18-110.47-1.18V199.35Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#ededf4"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M1041.23,199.35V697.64c-.42.31-40.24-.46-42,.18h-68.5V199.35Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#ededf4"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 155.96,
  y: 96.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 155.96,
  y: 119.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 155.96,
  y: 142.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 155.96,
  y: 165.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 155.96,
  y: 188.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 156.2,
  y: 256.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 156.2,
  y: 279.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 156.2,
  y: 302.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 156.2,
  y: 325.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 156.2,
  y: 348.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 156.43,
  y: 416.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 156.43,
  y: 439.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 156.43,
  y: 462.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 156.43,
  y: 485.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 156.43,
  y: 508.27,
  width: 80,
  height: 10,
  fill: "#fff"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 76.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 76.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 76.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 76.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 76.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 118.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 118.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 118.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 118.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 118.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 160.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 160.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 160.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 160.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 160.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 202.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 202.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 202.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 202.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 202.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref60 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 244.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 244.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref62 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 244.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 244.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref64 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 244.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 286.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref66 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 286.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 286.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref68 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 286.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref69 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 286.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref70 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 328.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref71 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 328.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref72 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 328.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref73 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 328.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref74 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 328.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref75 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 370.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref76 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 370.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref77 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 370.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref78 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 370.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref79 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 370.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref80 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 412.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref81 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 412.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref82 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 412.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref83 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 412.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref84 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 412.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref85 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 454.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref86 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 454.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref87 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 454.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref88 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 454.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref89 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 454.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref90 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 496.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref91 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 496.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref92 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 496.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref93 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 496.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref94 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 496.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref95 = /*#__PURE__*/React.createElement("rect", {
  x: 880.2,
  y: 538.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref96 = /*#__PURE__*/React.createElement("rect", {
  x: 892.2,
  y: 538.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref97 = /*#__PURE__*/React.createElement("rect", {
  x: 904.2,
  y: 538.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref98 = /*#__PURE__*/React.createElement("rect", {
  x: 916.2,
  y: 538.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref99 = /*#__PURE__*/React.createElement("rect", {
  x: 928.2,
  y: 538.27,
  width: 10,
  height: 10,
  fill: "#fff"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M649.25,310.44l-31.57,4.72-65.15,9.73L409,346.34l-.51.07-47,309.5-.19,1.23,535-233.62,1.42-.62Zm216.23,99.37L849,416.05l-24.3-11.81,16.35-5.49ZM604.11,323.29l.54-.08,6,3.71-4.09.66-7.28,1.17,0,0-5.57-3.85,8.54-1.3ZM599,330.21l5.29,3.66,2.67,1.85-2.67.53-2,.4L597,337.7l-7.66-5.93,9.06-1.46h0Zm8.34-1.35h0l5.15-.84,8.09,5-11.75,2.34-2.59-1.79-5.29-3.66Zm22.87-3.7,10.24-1.65,7.63,4-11,2.19-4.1-2.34-3.64-2.08Zm9.68,7.75,0,0,4.71,2.69-1.08.22-11.87,2.36-7.37-4.53,12.54-2.49ZM606,344.72l10.81-2.16,1.6,1.12h0l.37.25,2.31,1.6-11,2.37L607,345.46l-.23-.19Zm12.69-2.53,12.69-2.53,3,1.84.56.34.86.53L623,345.14l-2.12-1.47h0l-.38-.27ZM578,418.88l-24.88,6.56-7.21-12.75L569.42,407Zm-9.4-13.11-23.4,5.68-6-10.63,21.64-5.12.46-.11,5.73,8,0,.07Zm75.53-44.33,2.3,1.6-5.7,1.23L634,365.71l-.72.16-1.83-1.42-2.12-1.65-9-7,11.75-2.68,8.42,5.83h0Zm-41.36-1.6,1.54-.35,14.34-3.27,8.92,6.91,2.12,1.65,1.9,1.47-16.88,3.65-2.39-2-1.62-1.36-7-5.88ZM633,367.35l1.55,1.2.54.42,7.66,5.93L625.45,379,616,371Zm-20,2.92-5.47,1.18-.1,0-28.67,6.2-1.19.26-8.78-10.35,9.65-2.2L601,360.22Zm-34.2,8.8,27.56-6h0l2.37-.51,5.59-1.21,9.49,8-6.34,1.5-2.33.55-28.82,6.82-7.52-8.86-.23-.27Zm15.34,20.51-14.7,3.56-9.4,2.28-7.31-10.17,16.39-3.88,6.7-1.58Zm-14.67,5,15.67-3.79,9.42,11.11-24.72,6.52-.42.11-8.52-11.87Zm7.86-15.12,29-6.86,2.33-.55,6.45-1.53,10.68,9-4.65,1.13-9,2.17h0l-26.54,6.44Zm39.47-9.34,17.35-4.1,3.65,2.83,7.62,5.91-7.62,1.85-10.33,2.5Zm21-3-1.93-1.5,1.93-.46,12-2.83,12.18,8.43-14.82,3.59Zm0-3.38-3.33.79-8.3-6.43L634.72,367l3.68-.8,9.36-2,.17,0,10.28,7.12Zm-28.83-19L611.54,349l11.12-2.39,7.9,5.47Zm-1.74.4-12.93,2.95-2,.45-.86.2-7.12-6,8-1.72,2-.43,5.52-1.19Zm-17.48,4L578.36,364l-10.62,2.42L562,359.67l16.12-3.47,14.42-3.11Zm-33.48,7.63-12.16,2.77-8.46,1.93-5.12-7.13,13.3-2.86L560.5,360Zm-12.11,4.18,13.11-3L576,378.26l-21.47,4.65-.6.13-7.45-10.38ZM577,379.45l1.82,2.14,5.95,7L579.05,390,561.82,394l-7-9.78ZM596.6,400.4l24.58-6h0l10.65-2.59,5.24-1.27,10.68,9,.8.67-.8.21-41.76,11Zm51.16-2.62-9-7.6,9-2.18,9-2.19L668.6,395l-18.41,4.86Zm10.73-12.39,14.94-3.62,12.48,8.64-15.63,4.12Zm16.74-4.05,17.16-4.16,13.12,8.06L687.66,390Zm-1.52-1.06-12.16-8.42,16-3.79,13.16,8.09ZM660,370.8l-10.24-7.09,15.33-3.31L675.92,367Zm-11.79-8.16-.47-.33-13.84-9.58,13.66-3.12.18.11,15.65,9.63Zm-15.85-11-7.87-5.45,13-2.8,8.41,5.17Zm-27.36-6h0l3.33,2.57-4.1.88-2,.43-9.32,2-4.1-3.45,5-1h0l1.84-.36.08,0,6.45-1.29,2-.39,0,0,.54.43h0Zm-27,4.6,9.11-1.82,4.13,3.48-13.12,2.83L561,358.48l-3.47-4.09Zm-18.51,8.5-5.75,1.24-14.13,3-3.21-4.48,17.17-3.43,2.43-.48Zm-21.35,4.6-18,3.87-2.77-4.88,17.52-3.5Zm.88,1.22,5.13,7.15-19,4.33-4.28-7.57Zm6,8.36,7.44,10.36-20.68,4.48-5.92-10.47Zm8.32,11.59,1.31,1.79v0l5.71,8-.53.12-21.41,5.07-5.93-10.49Zm-9.58,27.2L518.13,418l-4.69-11.09,24.3-5.75Zm.7,1.25,7.23,12.77L524.47,433l-5.79-13.7Zm7.93,14L561,442.2l-29.1,8.28L525,434.26Zm1.38-.36,25-6.6L589,434.23l-26.63,7.58Zm26.47-7L605.51,413l11.28,13.29-26.41,7.51Zm26.78-7,0,0,40.77-10.76,2.09-.55L663.67,413l-45.42,12.92Zm44.46-11.77L670,396l14.3,11.08-19,5.41Zm20.18-5.32,15.74-4.15,15.14,10.49-16.61,4.72ZM689.15,391l18-4.74,16,9.83-18.87,5.37ZM709,385.75l16.1-4.24,16.39,9.35-16.53,4.7Zm-1.62-1-13.07-8L710,372.91l13.37,7.63Zm-14.72-9.06-13.15-8.08,15-3.55,13.75,7.84Zm-14.81-9.11L667.06,360l14.68-3.18,11,6.27Zm-12.46-7.66-15.86-9.75L663,346.1l17,9.68Zm-17.54-10.79-.06,0L639.44,343l8.32-1.79,4.82-1,8.63,4.93Zm-.06-8.35-4.48,1-.1,0L637.74,342l-.63-.39-.58-.36-3.15-1.94,11.54-2.3,1.51-.3,4.35,2.48Zm-18.1-1.19-12.54,2.5-6.73-4.67,11.9-2.36Zm-14.42,2.87-10.67,2.13-.31-.24-2-1.55-3.86-3,3.86-.77,2-.4,4.24-.84Zm-13,2.09.52.4-.52.1L587.49,347l-5.78-4.87,14.9-3Zm-16.5,3.79-8,1.61h0l-21.17,4.22-3.15-3.71L552.14,348l1.18-.23,19-3.78h0l7.67-1.53Zm-32.31,4.34,1.53,1.8-1.45.29-18,3.6-3.8-5.3,18.89-3.75Zm-19.42,6-17.35,3.46-3.08-5.44,16.63-3.31Zm-18.78,3.75-19.4,3.87-2.36-5.6L512.17,356Zm.72,1.26,2.77,4.9-20.09,4.33-2.25-5.33Zm3.48,6.16,4.3,7.59-21.15,4.82-3.4-8.05Zm5,8.84,5.91,10.45-22.78,4.93-4.44-10.52Zm6.62,11.71L537,399.9l-24.13,5.71-4.76-11.26Zm-14.3,28.93L491,424.58,487.7,413l24.38-5.77Zm.54,1.29,5.8,13.72-27.6,7.28-4.17-14.71Zm6.34,15,6.87,16.24-29.72,8.45-4.91-17.37Zm7.41,17.52,8,19L507,481l-5.76-20.33Zm1.34-.38,29.26-8.33,10.07,17.79-31.3,9.54ZM563,443.05l26.8-7.63,11.94,16.64-28.68,8.75Zm28.21-8,26.53-7.54,13.29,15.65-27.9,8.51Zm28-8,45.71-13,16.34,13.76L632.5,442.7Zm47.31-13.46,19.1-5.43,17,13.15-19.75,6Zm20.74-5.9L704,403l18,12.46-17.78,5.42Zm18.45-5.24,19-5.4,19,11.71-20.08,6.12Zm20.79-5.92,16.62-4.72L762.72,403l-17.19,5.24ZM745,391.29l15.56-4.43,20.17,10.64-16.18,4.94Zm-1.67-1L727,381l15-3.95,16.83,8.87ZM725.26,380l-13.32-7.59,14.56-3.53,13.65,7.2Zm-15.06-8.59-13.75-7.84,13.8-3.26,14.41,7.6Zm-15.5-8.84-10.94-6.24,13.44-2.9,11.2,5.9ZM682,355.34l-17-9.69,12.16-2.78,18.16,9.58Zm-18.77-10.7-8.6-4.91,11.77-2.54,8.9,4.7Zm-10.4-5.93-4.31-2.46,11.67-2.33,4.31,2.27Zm-6.13-3.5-7.79-4.45,11.11-2.2,8.24,4.34ZM635,330.13l-12.44,2.48-8-4.92,12.59-2Zm-39.83,7.93L580.36,341l-7.76-6.53,14.84-2.4Zm-16.53,3.29-7.58,1.51-17.78,3.53-2.15.43L544.49,339l8.48-1.37,10.53-1.7,7.3-1.18Zm-29.06,5.77-18.74,3.73-6.2-8.63,18.27-3Zm-20.23,4-16.46,3.27L507.54,345l15.57-2.52Zm-17.89,3.56-18.51,3.68L488.56,348l17.52-2.83Zm-19.9,4-18.21,3.62L470.15,351l17-2.75Zm.55,1.29,2.37,5.6-19.12,3.81-1.63-5.75Zm2.92,6.9,2.26,5.35-19.91,4.29-1.64-5.79Zm2.81,6.64,3.4,8.06-21.07,4.8-2.42-8.53Zm3.95,9.35,4.44,10.51-22.69,4.9-3-10.57Zm5,11.8,4.77,11.28-24.22,5.73-3.41-12.07ZM489.64,424.9l-28.24,6.84-1.56-12.16,26.51-6.27Zm.37,1.33L494.18,441,463.62,449l-2-15.9Zm4.55,16.06,4.93,17.4-33.29,9.47-2.4-18.76Zm5.3,18.73,5.77,20.36-36.43,11.1-2.82-21.94ZM506,482.7l7,24.68-40.15,13.48-3.47-27Zm1.32-.4,32.33-9.86,9.63,22.77-35,11.73ZM541,472l31.45-9.59,11.88,21-33.72,11.32Zm32.8-10,28.84-8.79,13.92,19.39L585.65,483ZM604,452.82l28-8.54,15.3,18-29.43,9.88Zm29.46-9,49.07-15,18.34,15.45-52.14,17.5Zm50.64-15.44,19.83-6L722.8,437l-20.39,6.84Zm21.44-6.54,17.9-5.45,19.8,13.71-18.88,6.33Zm19.58-6,20.21-6.16L766,422.47l-21.16,7.1Zm22-6.69,17.27-5.27,21.08,12-17.7,5.95Zm19.09-5.82,16.26-5,21.49,11.33-16.73,5.62Zm18.13-5.53,14.78-4.51,22,10.67-15.31,5.13Zm-1.73-.92-20.12-10.61,14-4,20.82,10.11ZM760.7,385.39l-16.78-8.85L757.28,373l17.32,8.41Zm-18.58-9.8-13.59-7.17,12.86-3.12,14,6.79Zm-15.44-8.14-14.39-7.59,12-2.85,15.11,7.34Zm-16.24-8.57L699.3,353l11.61-2.51,11.46,5.57Zm-13-6.88-18.2-9.6,10.26-2.33,19.44,9.44Zm-20.07-10.58-8.86-4.68,9.8-2.11,9.21,4.47Zm-10.76-5.68-4.26-2.25,9.65-1.92,4.3,2.08Zm-6.2-3.27-8.23-4.34,9-1.8,8.73,4.24Zm-10.17-5.36-7.52-4,9-1.45,7.49,3.64Zm-9.55-5-6.4-3.37,8.54-1.31,6.7,3.26Zm-2.26.37L628.73,324h0l-1.32.21-6.19-3.52,2.84-.43,7.91-1.21Zm-13.16,2.13-12.48,2-6-3.69L619,321Zm-27.9,4.5-9.52,1.54-5.2-4,9.11-1.39ZM586,330.91l-14.74,2.38-5-4.21,14.51-2.22Zm-16.54,2.67-7.21,1.17-9.28,1.5-9.47,1.53-3.93-4.63,13.22-2,4.73-.73,6.93-1.05ZM541.86,338,523.73,341l-3.49-4.86,17.68-2.7Zm-19.65,3.17-15.4,2.49-2.89-5.11,14.79-2.26Zm-16.85,2.72L488,346.74l-2.27-5.38,16.72-2.55Zm-18.75,3-16.84,2.72L468.18,344l16.15-2.46ZM468.4,349.9l-17.14,2.77-.77-5.93,16.31-2.49Zm.38,1.34,3.2,11.32-19,3.77L451.43,354Zm3.58,12.65,1.63,5.76-20,4-.77-5.94Zm2,7.09,1.64,5.81-21.08,4.54-.81-6.32Zm2,7.14,2.42,8.55-22.53,5.14-1.17-9.11Zm2.8,9.88,3,10.56-24.36,5.27-1.37-10.65Zm3.36,11.89L486,412l-26.32,6.22-1.66-13Zm-22.5,32.18-30.29,7.34.22-12.77,28.51-6.74Zm.18,1.38,2,15.93L429.43,458l.3-17.2Zm2.22,17.31,2.41,18.78L429,479.73l.36-20.26ZM465,470.92l2.82,22-39.26,12,.42-23.69Zm3,23.36,3.46,27L428,535.89l.53-29.58Zm3.64,28.42,4.44,34.57-48.78,18.48.68-38.4Zm1.34-.45,40.35-13.54,8.81,31.12-44.73,16.94Zm41.66-14,35.14-11.79,12,28.34-38.33,14.52ZM551.13,496,585,484.67l14.61,25.83-36.53,13.83Zm35.21-11.82,31-10.41,16.91,23.56L600.93,510Zm32.41-10.87,29.54-9.91,18.39,21.66-31.06,11.76Zm31-10.39,52.42-17.59,21.54,18.15-55.61,21.06Zm53.95-18.1L724.11,438l22,17-21,7.94Zm22-7.39,19-6.37,22.84,15.81-19.9,7.54Zm20.62-6.92,21.27-7.14,23.63,14.53-22.13,8.38Zm23-7.71,17.78-6,23.85,13.6-18.08,6.85Zm19.53-6.56,16.82-5.64,24.09,12.71-17.14,6.49ZM807.43,410l15.4-5.16,24.4,11.85-15.79,6Zm31.78-12.11-16.28,5.46L801,392.75l16-4.87ZM815.12,387l-15.9,4.84-20.77-10.09,15.4-4.38ZM791.9,376.51l-15.31,4.36-17.27-8.39,15-4Zm-19.62-8.88-14.86,3.92-13.92-6.76,14.65-3.55Zm-16.17-7.32-14.56,3.53-15.1-7.33,13.95-3.3Zm-17.77-8-13.85,3.27L713.09,350l13.71-3Zm-13.65-6.18L711.09,349l-19.48-9.46L704,336.75ZM702,335.81l-12.32,2.8-9.17-4.45,11.15-2.4-.15-.7Zm-11.51-5.21-12,2.58-4.24-2.06,10.26-2.05-.26-1.3Zm-6.32-2.86-12,2.38-8.73-4.24L675,323.59Zm-11.33-5.13-11.42,2.28L654,321.31l11.72-1.89Zm-9.33-4.22-11.6,1.87L645.19,317l11.41-1.74Zm-14.41-6.52,5.25,2.37L643,316l-5-2.44Zm-13.48,2,5,2.45-8.41,1.28-4.77-2.51Zm-16.43,2.45h0l6-.89,4.78,2.52-7.33,1.12-3.3.51-4.54-2.6Zm-6.61,1,4.55,2.6-12.14,1.85-4.34-2.66Zm-14,2.1,4.35,2.68-10.77,1.64-4-2.76Zm-12.4,1.86,4,2.76-9,1.37-3.67-2.84Zm-10.54,1.57,3.68,2.85-14.41,2.2L561.33,325Zm-23,3.44.35-.05,6.6-1,3.47,2.93-6.82,1-3.48.53-14.21,2.17-2.66-3.13ZM534.21,329l2.67,3.13-17.54,2.68L517,331.6Zm-18.73,2.8,2.33,3.24-14.62,2.23-1.9-3.35Zm-15.65,2.33,1.9,3.36-16.55,2.53-1.47-3.48Zm-17.53,2.62,1.48,3.48-16,2.44-1-3.6Zm-16.9,2.53,1,3.6-16.1,2.46-.48-3.74Zm-34,5.07,17-2.54.48,3.74-17.58,2.68Zm-.09,5.28L449.13,347l.76,5.95-18.65,3Zm-.14,7.65,18.86-3.05,1.58,12.34L431,370.72ZM431,372.13,451.83,368l.76,5.94-21.75,4.34Zm-.13,7.53,21.95-4.37.81,6.33-22.89,4.93Zm-.15,8.31,23.09-5,1.17,9.12-24.43,5.57Zm-.2,11.13,24.63-5.61,1.37,10.63-26.19,5.66Zm26.17,6.39,1.67,13-28.3,6.7.25-14Zm-46.91-57.86,20.33-3-.07,3.88-20.87,3.19Zm-.82,5.46,21-3.22-.11,6.26-21.94,3.55Zm-1.22,8,22.14-3.58L429.59,371l-24.13,4.8Zm-2.45,16.13,24.32-4.84-.1,6.13-25.18,5ZM404.06,385l25.37-5.06-.12,6.91-26.39,5.68Zm-1.36,9,26.58-5.72-.17,9.73-28,6.38Zm-1.8,11.85,28.19-6.42-.19,10.66-29.62,6.41ZM399.06,418l29.81-6.45-.25,14.05-31.86,7.53Zm-2.52,16.6L428.6,427l-.23,12.78L394.51,448Zm-2.26,14.88,34.07-8.25L428,458.4l-36.58,9.65Zm-3,20.11,36.78-9.7-.36,20.28-39.74,11.31Zm-3.55,23.38,39.95-11.36-.42,23.73-43.42,13.23ZM383.57,520l43.61-13.29-.52,29.61-48,16.11ZM425,627.83l-61.93,27,8.59-56.58,54.23-20.54Zm-53.11-31.09L378.41,554l48.22-16.18L426,576.28Zm54.5,30.48.89-50,49-18.55L482,603Zm56.88-24.83-5.67-44.21,44.93-17,11.1,39.23Zm51.64-22.56-11.09-39.16,38.49-14.57,14.9,35.26Zm43.57-19-14.88-35.2,36.68-13.9,18,31.74Zm41-17.92-17.92-31.67,33.5-12.69,20.52,28.6Zm37.39-16.33L636.45,498l31.18-11.8,22.09,26ZM691,511.67l-22-26,55.88-21.16,25.29,21.31Zm60.54-26.44L726.34,464l21-8L773,475.88Zm22.87-10-25.56-19.81,20-7.57,26.4,18.28Zm22.32-9.75-26.31-18.23,22.24-8.42,27,16.63Zm24.5-10.7-27-16.56,18.16-6.88,27.08,15.45Zm19.87-8.68-27-15.39,17.21-6.52,27.16,14.32Zm19-8.29-27.06-14.27,15.86-6,27.28,13.25Zm17.75-7.75-27.17-13.2,16.55-6.27,27.11,12.27Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#ededf4"
});

var _ref101 = /*#__PURE__*/React.createElement("polygon", {
  points: "591.2 211.85 591.2 276.11 522.51 291.62 498.14 260.6 495.99 198.54 495.93 196.35 557.96 185.27 591.2 211.85",
  fill: "#ededf4"
});

var _ref102 = /*#__PURE__*/React.createElement("polygon", {
  points: "591.2 212.3 591.2 276.11 523.24 291.46 522.51 291.62 498.14 260.6 495.99 198.54 521.4 221.82 591.2 212.3",
  opacity: 0.1
});

var _ref103 = /*#__PURE__*/React.createElement("polygon", {
  points: "591.2 212.5 591.2 276.11 523.24 291.46 521.4 221.82 590.09 212.96 591.2 212.5",
  opacity: 0.1
});

var _ref104 = /*#__PURE__*/React.createElement("polygon", {
  points: "553.46 206.18 550.08 200.31 546.7 194.45 543.31 200.31 539.93 206.18 545.7 206.18 545.7 233.27 547.7 233.27 547.7 206.18 553.46 206.18",
  fill: "#123f73"
});

var _ref105 = /*#__PURE__*/React.createElement("polygon", {
  points: "574.08 262.41 570.7 256.54 568.36 260.6 550.88 244.04 549.51 245.49 567.33 262.38 567.31 262.41 563.93 268.27 570.7 268.27 577.46 268.27 574.08 262.41",
  fill: "#123f73"
});

var _ref106 = /*#__PURE__*/React.createElement("polygon", {
  points: "582.12 230.93 575.76 228.6 576.82 234.71 554.02 238.78 554.37 240.75 577.16 236.68 578.08 241.94 583.27 237.6 588.47 233.26 582.12 230.93",
  fill: "#123f73"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M367.3,424.3c-1.68-11.25-11.89-37.48-11.89-37.48h0c-.18-.79-.38-1.56-.61-2.33-7.25-24.93-17.29-27.14-17.29-27.14l-35.94-7.66a2.75,2.75,0,0,1,.74.72c-.18,0-.37,0-.57.08a14.09,14.09,0,0,1-3.15-6.81c-.07-.37-.13-.76-.18-1.15a25.28,25.28,0,0,0-2.06-38c-.37-.29-.75-.58-1.15-.85,1.7-1.8,1.75-4.31.49-6.81-2.84-5.89-9-9.61-15.32-11.42-4.84-1.39-10.09-1.84-14.88-.32a54.27,54.27,0,0,0-7.78,3.61c-4.78,2.39-10,4.27-13.63,8.19a4.06,4.06,0,0,0-1.36,3.29,8.89,8.89,0,0,0,1.35,2.39c1,1.79.76,4.05.07,6s-1.73,3.76-2.22,5.76-.3,4.35,1.2,5.78a26,26,0,0,0,2.25,1.59,12,12,0,0,1,2.14,2.4l4.26,5.75a59,59,0,0,1,5.32,8.11,39.36,39.36,0,0,0,3.3,6.18,9,9,0,0,0,1.42,1.48l-.42-.16a6.45,6.45,0,0,0,4.76,1.83h.22a1.29,1.29,0,0,0,.86-.35l0,.79c.08,2.76.06,5.7-.13,8.46l-.33-.17a2.89,2.89,0,0,0-3.1.33l-33.11,26.55s-7.2,9.85-6.19,26.83l-5.8,25.48s-7.26,21.62-1.68,37.07,8.81,24.26,8.81,24.26,2.24,17.54,5.58,19,4.8,2.21,4.8,2.21l.67,4.19h0s.22.41.61,1.1c2.44,4.24,11.47,19.2,16.72,17.6a68,68,0,0,1,.85,12.3l5.19,34.85s3.62,9.49,3.4,14.45,4.24,12,4.24,12a23,23,0,0,0-2.23,16.22c2.12,9.26,4.8,52.06,4.8,52.06l3.9,10.37L274.15,705a11.67,11.67,0,0,1-2.4,5.39c-2.51,2.72-2.34,5.87-8.37,9.59s-9.87,5.13-9.87,10.09a12.93,12.93,0,0,1-.18,2c-.56,3.63-1.65,5.58,9.47,6.64a29.26,29.26,0,0,0,21.75-7.28s1.93-3.48,11-4.88c0,0,3.09-.17,3.26-2.9.06-.94.05-2.75,0-4.73-.15-3.79-.51-8.2-1-8.42s-1.66-4.08-2-5.46h2.51s2.35-17.54,0-28.9-.22-19.41-.22-19.41l-.45-30s-3.12-3.31-.67-9.16,0-34.74,0-34.74.9-10.37,3.46-12.8.13-15.19,0-15.85l4.57,15.3s2,30.45,6.25,36l1.22,13.78s8.7,12.69,7,19.53,1.79,31.55,1.79,31.55v25.26s-3.91,10.14,1.56,13.78l2.35-.09c-.8.72-1.37,1.81-2.27,2.74-1.05,1.08-1.64,5.17-2,8.69-.28,3-.37,5.54-.37,5.54a9.18,9.18,0,0,0,6.7,4c4.35.25,18.74,11.25,18.74,11.25s14.23,0,17.91-.74l.21,0a4.87,4.87,0,0,0,2.78-2.27,5.74,5.74,0,0,0,.67-4.17c-.45-2.18-2.18-4.56-6-6.59-9.55-5-11-9.75-11-9.75l-6.24-9.37.89,0s-.56-9.92,6.24-21.07L351,638.4s2.79-16.88-2-26c0,0-.39-9.71,2.81-12.68s-4.26-33.1-4.26-33.1-1.53-16.16-3.37-30.91l0,0c7.53,7.14,15.35-18.58,16.66-23.14l.19,0s0-.13-.09-.34l.09-.33h0s-1.67-5.95-.45-4.74,4.24-3.31,4.24-3.31-.44-24.6,4.8-37S367.3,424.3,367.3,424.3ZM344.87,440l0-.06c.78,15-.15,47.07-.15,47.07s-1,4.1-2.14,8.94l-.79-30.45h0l-.75-28.68Zm-96-10.35s3.79,47.43,0,54.27c-1.08,1.94-2,5.41-2.74,9.37-1.25-3.29-3.9-11-3-15.11,1.22-5.29-2.46-19.19-2.46-19.52s-.33-7.72,2.35-13.4.89-8.11.89-8.11S246.15,427.83,248.83,429.6Z",
  transform: "translate(-56.56 -127.37)",
  fill: "url(#a2e0af23-4ced-4921-9ce0-827007506601)"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M258.06,536.41c-3.3,14.53-16.44-7.43-19.43-12.7l-.61-1.09,1.43-6.68,7.53-3.07a21,21,0,0,1,3.37,2.19C254.47,518.28,260.61,525.17,258.06,536.41Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#a1616a"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M360,512.65s0,.11-.08.32l-.11.36c-1.28,4.53-8.95,30.06-16.34,23-8.1-7.77-4.16-25.63-4.16-25.63h.05l17-1.74,3.37,3.46s0,0,0,0Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#a1616a"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M350.14,638.24l.43,48.71c-6.67,11.07-6.12,20.92-6.12,20.92l-22,.87c-5.37-3.61-1.53-13.68-1.53-13.68V670s-3.4-24.52-1.76-31.31-6.89-19.38-6.89-19.38l-1.21-13.68c-4.16-5.48-6.13-35.7-6.13-35.7l-4.48-15.19c.12.66,2.44,13.39,0,15.74s-3.39,12.7-3.39,12.7,2.41,28.69,0,34.49.65,9.09.65,9.09l.44,29.78s-2.08,8,.22,19.26,0,28.69,0,28.69H274.7l.11-12.15L271,682s-2.63-42.48-4.71-51.68a23.06,23.06,0,0,1,2.19-16.09s-4.38-7-4.16-11.94S261,588,261,588l-5.09-34.6a67,67,0,0,0-2.52-19.71c-3-9.85-7.33-22.77-7.33-22.77l4.94.44,25,2.22s60.65-4.08,63.37-.69a11.18,11.18,0,0,1,1.14,3.53c2.72,12.24,6.32,50.56,6.32,50.56s7.34,29.89,4.19,32.85-2.76,12.58-2.76,12.58C352.87,621.48,350.14,638.24,350.14,638.24Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#2f2e41"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M298.87,723c-.17,2.71-3.2,2.87-3.2,2.87-8.87,1.4-10.76,4.85-10.76,4.85a28.55,28.55,0,0,1-21.35,7.23c-10.91-1-9.84-3-9.29-6.6a12.67,12.67,0,0,0,.18-2c0-4.93,3.77-6.32,9.69-10s5.74-6.82,8.21-9.52,2.71-8,2.71-8c2.79-4.85,9.85.73,9.85.73.33,1.72,10.84,1.48,10.84,1.48s1.4,5.58,2.11,5.91c.48.22.83,4.6,1,8.36C298.91,720.22,298.93,722,298.87,723Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#303d5c"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M298.87,723c-.17,2.71-3.2,2.87-3.2,2.87-8.87,1.4-10.76,4.85-10.76,4.85a28.55,28.55,0,0,1-21.35,7.23c-10.91-1-9.84-3-9.29-6.6,4.87,1.21,14.2,2.9,19.63-.06,7.56-4.1,13-7,13-7l11.95-6C298.91,720.22,298.93,722,298.87,723Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M365.7,737.56a4.78,4.78,0,0,1-2.73,2.26l-.21,0c-3.61.73-17.58.73-17.58.73s-14.12-10.91-18.39-11.16a9,9,0,0,1-6.57-4s.08-2.54.36-5.49c.33-3.5.91-7.56,1.94-8.63,1.89-2,2.3-4.68,6.57-3,0,0,6.07-10.69,13.21-2.43l7.4,11.22s1.39,4.68,10.76,9.69c3.75,2,5.45,4.37,5.89,6.53A5.8,5.8,0,0,1,365.7,737.56Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#303d5c"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M365.7,737.56c-.84.71-1.76,1.47-2.73,2.26l-.21,0c-3.61.73-17.58.73-17.58.73s-14.12-10.91-18.39-11.16a9,9,0,0,1-6.57-4s.08-2.54.36-5.49c4.34,1.3,10.93,3.6,12.7,6.07,2.7,3.77,10.93,9,10.93,9s15.33-1.47,22.14-1.68A5.8,5.8,0,0,1,365.7,737.56Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M306,355.48l-20.21,21.35s-24.47-1.8-20.2-9c2.18-3.68,2.52-11.39,2.33-18.09-.18-6.46-.85-12-.85-12s34.33-17.08,31.7-1.15a26.3,26.3,0,0,0-.1,9.1C300.19,353.73,306,355.48,306,355.48Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#a1616a"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M298.79,336.59a26.3,26.3,0,0,0-.1,9.1c-4.58,4.63-10.94,3.61-18,3.61-4.66,0-9.66.07-13.41-2.14-.18-6.46-.22-9.42-.22-9.42S301.42,320.66,298.79,336.59Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M306,326.58a25.3,25.3,0,0,1-25.3,25.29A25.29,25.29,0,1,1,306,326.58Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#a1616a"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M340.42,516.4c-6.29,15-46.81,15.3-46.81,15.3V515.36l-2.45-.16c1.06,4.68-1.49,16.09-1.49,16.09-32,4.52-39.82-13.71-39.82-13.71l1.11-6.24,25,2.22s60.65-4.08,63.37-.69A11.18,11.18,0,0,1,340.42,516.4Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M293.61,529.73V513.39l-2.45-.16c1.06,4.68-1.49,16.09-1.49,16.09-24.1,3.4-34.48-6.09-38.14-11a15.24,15.24,0,0,1-1.68-2.72l9.77-55,2.3-81,3.53-14.2.81-6.82v-.08l.09,0,2.49,1.07,14.91,6.45,16.94-12.79.24-.19.85-.63,1.4,1.12,3.48,2.79,11.17,72.11s19.37,55.52,23,77.93c.14.89.26,1.72.35,2.51C343.54,529.35,293.61,529.73,293.61,529.73Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#e1e7ef"
});

var _ref120 = /*#__PURE__*/React.createElement("circle", {
  cx: 229,
  cy: 240.27,
  r: 1.44,
  fill: "#67647e"
});

var _ref121 = /*#__PURE__*/React.createElement("circle", {
  cx: 229.66,
  cy: 253.4,
  r: 1.44,
  fill: "#67647e"
});

var _ref122 = /*#__PURE__*/React.createElement("circle", {
  cx: 231.1,
  cy: 274.67,
  r: 1.44,
  fill: "#67647e"
});

var _ref123 = /*#__PURE__*/React.createElement("circle", {
  cx: 233.48,
  cy: 297.58,
  r: 1.44,
  fill: "#67647e"
});

var _ref124 = /*#__PURE__*/React.createElement("circle", {
  cx: 234.92,
  cy: 319.1,
  r: 1.44,
  fill: "#67647e"
});

var _ref125 = /*#__PURE__*/React.createElement("circle", {
  cx: 236.36,
  cy: 342.01,
  r: 1.44,
  fill: "#67647e"
});

var _ref126 = /*#__PURE__*/React.createElement("circle", {
  cx: 235.79,
  cy: 364.67,
  r: 1.44,
  fill: "#67647e"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M267.22,468.59s-1.61,21.07-4.56,27.2-4.27,23.32-4.27,23.32l-6.86-.78a15.24,15.24,0,0,1-1.68-2.72l9.77-55,2.3-81,3.53-14.2.81-6.82.1,0a2.79,2.79,0,0,1,2.44,0l.33.17c-.1.28-.2.57-.28.86-2.68,8.38-3.68,23.82-3.68,23.82s3.84,28.25,4.27,41.39S267.22,468.59,267.22,468.59Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M250.35,515.06a4.11,4.11,0,0,1-.27.51c-2.66,4.5-9.4,7.36-11.45,8.14l-.61-1.09,1.43-6.68,7.53-3.07A21,21,0,0,1,250.35,515.06Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M232.11,407.54l-6.24,3.73-5.69,25.29s-7.12,21.46-1.65,36.78,8.65,24.09,8.65,24.09,2.19,17.41,5.48,18.83,4.71,2.19,4.71,2.19l.65,4.16s8.91-3,12.07-8.35-2.32-18.58-2.32-18.58-4.71-11.28-3.51-16.53-2.4-19-2.4-19.38-.33-7.67,2.29-13.3.88-8.05.88-8.05l-1.64-16.1Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#303d5c"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M340.94,511.67s-16.53,6.24-21.79.76-4.71-31.09-4.71-31.09-5-47.3-8.21-55.07-1.53-63.84-1.53-63.84-2.14-7.25-4-9.14a1.77,1.77,0,0,0-.39-.32l.63.13,2.25.49,3.48,2.79,11.17,72.11s19.37,55.52,23,77.93Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M360,513.31l-.19,0c-2.07.27-20.45,2.49-20.52-1.34a11.66,11.66,0,0,1,.07-1.32l17-1.74,3.37,3.46s0,0,0,0c.06.22.11.42.16.57Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M342.37,382.21l12.08,6.3s10,26,11.67,37.21c0,0,7.45,29.91,2.3,42.22s-4.7,36.72-4.7,36.72-3,4.49-4.17,3.28.44,4.71.44,4.71-20.63,2.74-20.72-1.31S344,487.91,344,487.91s1.31-46.1-.55-53.32S342.37,382.21,342.37,382.21Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#303d5c"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M306.34,431.3s-6.78,16.64-9,17.74.43,5.47.43,5.47S310.18,437.21,306.34,431.3Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M302.29,372.94c.08-.31-8.1,8-10.29,9.27S300,382.14,302.29,372.94Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M279.52,430s-12.48,8.07-10.84,11.26S279.52,430,279.52,430Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M302.18,547.8s10.63,6.83,27.16,8.54Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M276.67,564.22s9.86,12.37,14.35,12.7S276.67,564.22,276.67,564.22Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M290.47,612.72c-.44.22-5.59,11.17-10.84,11.5S290.47,612.72,290.47,612.72Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M336.12,636.7s9.77-2.19,11.94,4.82C348.06,641.52,347.4,639.33,336.12,636.7Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M329.56,676.77s11.82-2.41,14.34.88S329.56,676.77,329.56,676.77Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M296.09,682.36c0,.11-12,2.41-11.57,3.94s12.85,1.31,13.28-1.1A2.28,2.28,0,0,0,296.09,682.36Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M325.61,692.76s19.79-2.41,18.54,1.75S325.61,692.76,325.61,692.76Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M222,449c.11.33,13,2.08,14.78,6.24,0,0-12.7-5.91-14.67-5.91",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M240.21,482.87s-10.73,3.39-10,8.54S229.16,489,240.21,482.87Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M235.21,508.93s3.91-5.37,7.63-4.38S235.21,508.93,235.21,508.93Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M296.5,306.81a6.17,6.17,0,0,1-1.26.94c-3.11,1.8-3.95,4.58-5.44,7.78-1.36,2.93-2.88,6-5.64,7.7-3.56,2.15-8.26,1.36-12,3.24a9.32,9.32,0,0,0-4.95,9.15,26.48,26.48,0,0,0,1.05,4.19,29.51,29.51,0,0,1,1.13,9.11,1.23,1.23,0,0,1,0,.27,25.29,25.29,0,1,1,27.1-42.38Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M295.84,299.2c-2.78-5.84-8.82-9.53-15-11.33-4.74-1.38-9.89-1.83-14.6-.32a53.49,53.49,0,0,0-7.63,3.58c-4.69,2.37-9.85,4.25-13.38,8.14a4,4,0,0,0-1.33,3.26,8.53,8.53,0,0,0,1.32,2.37c1,1.78.74,4,.07,6s-1.7,3.73-2.18,5.72-.29,4.31,1.18,5.73a26.64,26.64,0,0,0,2.2,1.58,12,12,0,0,1,2.11,2.38l4.17,5.71a58.67,58.67,0,0,1,5.23,8,39,39,0,0,0,3.24,6.13c1.39,1.85,3.56,3.34,5.87,3.13a1.12,1.12,0,0,0,.92-.44,1.26,1.26,0,0,0,.12-.58,30.07,30.07,0,0,0-1.13-9.1,25.58,25.58,0,0,1-1.06-4.2,9.32,9.32,0,0,1,4.95-9.15c3.72-1.87,8.42-1.08,12-3.23,2.76-1.67,4.28-4.77,5.64-7.7,1.49-3.21,2.32-6,5.44-7.79S297.38,302.27,295.84,299.2Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#2f2e41"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M284.51,712.6s3.85,4.93,2.86,7.72S284.51,712.6,284.51,712.6Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M336.85,724.92s.86-6.61,4.31-6.67,3.61-.35,6.24.65,5.1,2.59,4.32,2.83-4.54-3.78-8.37-1.73A27.8,27.8,0,0,0,336.85,724.92Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M273,374.33l10.8-7.6s-15.85-9.36-17.74-8.05-3.18,13.15-3.18,13.15Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M272.92,373.83l10.84-7.76s-15.85-9.36-17.74-8-3.18,13.8-3.18,13.8Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#e1e7ef"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M272.92,373.83l10.84-7.76s-15.85-9.36-17.74-8-3.18,13.8-3.18,13.8Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.03
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M267.82,358.12l-.33-.17a2.81,2.81,0,0,0-3,.32L232,384.63s-7.06,9.77-6.08,26.64L245,438.42s2.19-9.2,4.82-7.45c0,0,3.72,47.08,0,53.87S244.48,517,244.48,517l12.59,1.42s1.32-17.19,4.27-23.32,4.57-27.19,4.57-27.19,2.66-30.62,2.22-43.76-4.27-41.38-4.27-41.38S264.93,366.24,267.82,358.12Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#303d5c"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M300.19,369.52l-13.51-5s17.2-18.83,19.34-8.38Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M300.19,368.87l-13.51-5S303.88,345,306,355.48Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#e1e7ef"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M300.19,368.87l-13.51-5S303.88,345,306,355.48Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.03
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M299.75,352.85a.74.74,0,0,1,.56.12Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M301.06,351.54l35.83,7.72s9.85,2.19,17,26.93-9.74,55.06-9.74,55.06l-3.73-3.16,1.87,72.26s-16.54,6.24-21.79.77-4.71-31.1-4.71-31.1-5-47.3-8.21-55.07S306,361.12,306,361.12,303.06,351.1,301.06,351.54Z",
  transform: "translate(-56.56 -127.37)",
  fill: "#303d5c"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M333.83,397.58c-.51.47-1.1,22.33,1.09,39a212.24,212.24,0,0,0,6.21,30l-3.25-66.68S335.36,396.16,333.83,397.58Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M329.45,378.75c.87.55,4.7,9.63,2.95,13.36S329.45,378.75,329.45,378.75Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M295.63,299.2a19.69,19.69,0,0,0-7.88-8.25,18.77,18.77,0,0,1,5.91,6.94c1.53,3.07,1.09,6.15-1.92,7.89s-3.95,4.58-5.44,7.78c-1.36,2.93-2.87,6-5.64,7.7-3.56,2.15-8.26,1.36-12,3.23a9.34,9.34,0,0,0-4.95,9.16,26.76,26.76,0,0,0,1.05,4.19,29.51,29.51,0,0,1,1.13,9.11,1.14,1.14,0,0,1-.12.58,1.11,1.11,0,0,1-.92.44,5.45,5.45,0,0,1-2.7-.5,6.27,6.27,0,0,0,4.67,1.81.9.9,0,0,0,1-1,29.75,29.75,0,0,0-1.12-9.1,25.58,25.58,0,0,1-1.06-4.2,9.32,9.32,0,0,1,5-9.15c3.71-1.87,8.41-1.08,12-3.23,2.77-1.67,4.28-4.77,5.64-7.7,1.5-3.21,2.33-6,5.44-7.79S297.16,302.27,295.63,299.2Z",
  transform: "translate(-56.56 -127.37)",
  opacity: 0.1
});

var SvgModeling = function SvgModeling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a3fdf556-7513-4367-833c-43bb1dab678b",
    "data-name": "Layer 1",
    width: 1086.87,
    height: 645.26,
    viewBox: "0 0 1086.87 645.26",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModeling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modeling.fb2d8ab3.svg";
export { ForwardRef as ReactComponent };